import Report from '../../../common/types/api/report'
import type { SpreadsheetGeneratorProps } from './index'

const setSpreadsheetSettings = (filesExcel: SpreadsheetGeneratorProps, report: Report): Report => {
    return {
        ...report,
        files: {
            ...filesExcel,
            excel: filesExcel.excel
        }
    }
}
const getSpreadsheetSettings = (report: Report): SpreadsheetGeneratorProps => {
    return report?.files
}
export { getSpreadsheetSettings, setSpreadsheetSettings }
